import styled from 'styled-components';

export const ContentWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow-y: auto;
`;

export const FormWrapper = styled.div`
  background-color: #fff;
  width: 95%;
  padding: 20px;
  margin-left: 10px;
`;

export const FormItemWrapper = styled.div`
  display: flex;

  .ant-form-item {
    margin-right: 10px;
    width: 100% !important;
    min-width: 400px;
  }

  .ant-form-item-label {
    min-width: 115px;
    width: 9%;
    text-align: left;
  }

  .ant-form-item-required::before {
    display: none !important;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const AlertConfigRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  .ant-form-item-label {
    min-width: 115px;
    width: 15%;
    text-align: left;
  }
`;

export const CustomizeAlert = styled.div`
  color: #0046ff;
  text-decoration: underline;
  font-weight: 600;
  margin-left: 4px;
  cursor: pointer;
  z-index: 99;
`;

export const RequiredFieldsNote = styled.p`
  &::before {
    content: '*';
    color: #f5222d;
    font-weight: 600;
  }
`;

export const Separator = styled.hr`
  color: #eee;
  width: 100%;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
  margin: 8px 0;
`;

export const TooltipMark = styled.div`
  &::before {
    content: '?';
    font-size: 10px;
    border: 1px solid #9b9b9b;
    border-radius: 50%;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 14px;
    width: 14px;
  }

  margin: 0 4px;
`;

export const CustomFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ErrorAndButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

export const CustomFieldError = styled.div`
  color: #f5222d;
`;

export const CustomFieldRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0;
  gap: 8px;
`;

export const CustomFieldRemove = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 16px;
  margin: 0 8px;
  cursor: pointer;
`;

export const StyledPara = styled.div`
  font-size: 14px;
`;

export const ConsentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const ConsentPara = styled.p`
  margin-left: 8px;
`;
